import { Action } from "@ngrx/store";

export const GET_LOOKUP_LIST = '[Lookup List] Get Lookup List';
export const GET_LOOKUP_LIST_SUCCESS = '[Lookup List] Get Lookup List Success';
export const GET_LOOKUP_LIST_FAIL = '[Lookup List] Get Lookup List Fail';

export class GetLookupList implements Action {
    readonly type = GET_LOOKUP_LIST;
    constructor(){}
}

export class GetLookupListSuccess implements Action {
    readonly type = GET_LOOKUP_LIST_SUCCESS;
    constructor(public payload: any = null) {}
  }
  
  export class GetLookupListFail implements Action {
    readonly type = GET_LOOKUP_LIST_FAIL;
    constructor(public payload: any = null) {}
  }

  export type LookupListActions = 
  | GetLookupList
  | GetLookupListSuccess
  | GetLookupListFail;